import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { CmsLayout } from "@/components/cms/CmsLayout";
import LoginPage from "@/pages/LoginPage";
import ChangePasswordPage from "@/pages/ChangePasswordPage";
import ConfiguratorPage from "@/pages/ConfiguratorPage";
import { PublicLayout } from "@/components/public/PublicLayout";
import { CookieConsent } from "@/components/CookieConsent";
import { Analytics } from "@/components/Analytics";
import HomePage from "@/pages/public/HomePage";
import PortfolioPage from "@/pages/public/PortfolioPage";
import FaqPage from "@/pages/public/FaqPage";
import ContactPage from "@/pages/public/ContactPage";
import LegalPage from "@/pages/public/LegalPage";
import DashboardHome from "@/pages/cms/DashboardHome";
import EntityPage from "@/pages/cms/EntityPage";
import RequestsPage from "@/pages/cms/RequestsPage";
import MediaLibrary from "@/pages/cms/MediaLibrary";
import SettingsPage from "@/pages/cms/SettingsPage";
import HomepageEditor from "@/pages/cms/HomepageEditor";
import ContentPagesEditor from "@/pages/cms/ContentPagesEditor";
import ContentPageView from "@/pages/public/ContentPageView";

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PublicLayout />}>
              <Route index element={<HomePage />} />
              <Route path="portfolio" element={<PortfolioPage />} />
              <Route path="faq" element={<FaqPage />} />
              <Route path="contatti" element={<ContactPage />} />
              <Route path="scarpe-da-cerimonia" element={<ContentPageView pageKey="cerimonia" />} />
              <Route path="aziende" element={<ContentPageView pageKey="aziende" />} />
              <Route path="privacy-policy" element={<LegalPage type="privacy" />} />
              <Route path="cookie-policy" element={<LegalPage type="cookie" />} />
              <Route path="termini" element={<LegalPage type="terms" />} />
            </Route>
            <Route path="/configuratore" element={<ConfiguratorPage />} />
            <Route path="/cms/login" element={<LoginPage />} />
            <Route path="/cms/change-password" element={<ChangePasswordPage />} />
            <Route
              path="/cms"
              element={
                <ProtectedRoute>
                  <CmsLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<DashboardHome />} />
              <Route path="richieste" element={<RequestsPage />} />
              <Route path="temi" element={<EntityPage configKey="themes" />} />
              <Route path="modelli" element={<EntityPage configKey="models" />} />
              <Route path="aree" element={<EntityPage configKey="areas" />} />
              <Route path="tipologie" element={<EntityPage configKey="types" />} />
              <Route path="dettagli" element={<EntityPage configKey="details" />} />
              <Route path="prezzi" element={<EntityPage configKey="price_rules" />} />
              <Route path="homepage" element={<HomepageEditor />} />
              <Route path="pagine" element={<ContentPagesEditor />} />
              <Route path="portfolio" element={<EntityPage configKey="portfolio" />} />
              <Route path="faq" element={<EntityPage configKey="faqs" />} />
              <Route path="recensioni" element={<EntityPage configKey="reviews" />} />
              <Route path="media" element={<MediaLibrary />} />
              <Route path="impostazioni" element={<SettingsPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <CookieConsent />
          <Analytics />
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{ style: { borderRadius: 0, border: "1px solid hsl(0 0% 15%)" } }}
        />
      </AuthProvider>
    </div>
  );
}

export default App;
